module.exports = __webpack_public_path__ + "static/media/assets_preview.74a1c0ea.png";